module.exports = __webpack_public_path__ + "static/media/chevron.ba8aaca5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/chevron.svg
// module id = 70
// module chunks = 0